import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { withAuth, withoutAuth } from "../../config/axios";
import { useNavigate } from "react-router-dom";
import PrimaryLoading from "../Animation/PrimaryLoadingButton";
import Cookie from "js-cookie";
import CharFadeText from "../Animation/CharFadeText";
import OTPInput from "react-otp-input";

const NonMemberGiaForm = ({ setLoaderType, setLoading }) => {
  const [loader, setLoader] = useState(false);
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  const [giaNumber, setGiaNumber] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [accountType, setAccountType] = useState("Business");
  const [businessName, setBusinessName] = useState("");
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState(false);
  const [sendCode, setSendCode] = useState(false);
  const [count, setCount] = useState(0);
  const [isVerified, setIsVerified] = useState(false);
  const [isEmailAlreadyVerified, setIsEmailAlreadyVerified] = useState(false);
  const [error, setError] = useState(null);
  const [readRarity , setReadRarity] = useState(false);


  // 🚨 lockout states
  const [failures, setFailures] = useState(0);
  const [lockoutUntil, setLockoutUntil] = useState(null);
  const [lockoutRemaining, setLockoutRemaining] = useState(0);

  const timerRef = useRef(null);
  let deviceId = Cookie.get("deviceId");
  useEffect(() => {
    setLoaderType("progress");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!deviceId) {
      const newDeviceId = crypto.randomUUID();
      Cookie.set("deviceId", newDeviceId, {
        expires: new Date(Date.now() + 24 * 60 * 60 * 1000),
        secure: true,
        sameSite: "strict",
      });
    }
  }, [deviceId]);

  useEffect(() => {
    if (sendCode && count > 0) {
      timerRef.current = setInterval(() => {
        setCount((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timerRef.current);
  }, [sendCode, count]);

  useEffect(() => {
    if (lockoutUntil) {
      const interval = setInterval(() => {
        const diff = Math.max(
          0,
          Math.floor((lockoutUntil - Date.now()) / 1000)
        );
        setLockoutRemaining(diff);
        if (diff === 0) {
          clearInterval(interval);
          setLockoutUntil(null);
          setFailures(0);
        }
      }, 1000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line
  }, [lockoutUntil, failures]);

  const handleCode = async (e) => {
    const enteredCode = e;
  
    setCode(enteredCode);

    if (enteredCode.length === 6) {
      setCodeError(false);

      // 🚨 check lockout
      if (lockoutUntil && Date.now() < lockoutUntil) {
        setCodeError(true);
        return;
      }

      try {
        const res = await withoutAuth().post("users/verify-code", {
          giaNumber,
          email,
          code: enteredCode,
          deviceId,
        });

        if (res?.data?.status === 200) {
          setIsVerified(true);
          setFailures(0); // reset failures
          setCount(0);
          setLoader(false);
          setIsEmailAlreadyVerified(res?.data?.isEmailAlreadyVerified);
        } else {
          setCodeError(true);
          setFailures((prev) => {
            const next = prev + 1;
            if (next >= 5) {
              setLockoutUntil(Date.now() + 2 * 60 * 1000); // 2 minutes lock
            }
            return next;
          });
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const resetForm = () => {
    setStep(1);
    setGiaNumber("");
    setName("");
    setEmail("");
    setBusinessName("");
    setCode("");
    setSendCode(false);
    setIsVerified(false);
    setCount(0);
    setLoading(false);
  };

  const saveCookies = (emailVal, attemptedCount) => {
    Cookie.set("nonMemberEmail", emailVal, {
      expires: new Date(Date.now() + 24 * 60 * 60 * 1000),
      secure: true,
      sameSite: "strict",
    });
    if (!!attemptedCount){
      Cookie.set("nonMemberCredit", 5 - attemptedCount, {
      expires: new Date(Date.now() + 24 * 60 * 60 * 1000),
      secure: true,
      sameSite: "strict",
    });
    }
    
  };

  const navigateReport = (Id, report) => {
    navigate("/report", {
      state: {
        id: Id,
        report,
        action: "Create",
        fromURL: "rarity",
        type: "fromgia",
        from: "non-member",
      },
    });
  };

  const handleNext = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      if (step === 1) {
        const payload = {
          giaNumber,
          name,
          email: Cookie.get("nonMemberEmail") || email,
          businessName,
          deviceId,
        };

        if (Cookie.get("nonMemberEmail")) {
          setLoading(true);
          setLoaderType("progress");
          const { data } = await withAuth().post(
            "report/non-member-gia",
            payload
          );
          const { Id, report, msg, status, type, attemptedCount } = data || {};
          setLoading(false);

          if (status === 403 && type === "non-member") {
            setError(msg);
            return;
          }
          if (status === 203) {
            
            setLoading(false);
            navigate("/", {
              state: {
                from: "rarityreport",
                ischeck: true,
                type,
                nonMemberGia: giaNumber,
              },
            });
            return;
          }

          Cookie.set("nonMemberCredit", 5 - attemptedCount);
          if (status === 200 && msg === "Verification code sent successfully") {
            setStep(2);
            return;
          }
          if (status === 200 && Id && report) {
            navigateReport(Id, report);
          }
          resetForm();
        } else {
          setStep(2);
        }
      } else if (step === 2) {
        if (!sendCode || count === 0) {
          if (isVerified) {
            if (isEmailAlreadyVerified) {
              setLoading(true);
              setLoaderType("progress");
              const { data } = await withAuth().post("report/non-member-gia", {
                giaNumber,
                name,
                email,
                businessName,
                deviceId,
              });
              const { Id, report, msg, status, type, attemptedCount } =
                data || {};
              setLoading(false);

              if (status === 403 && type === "non-member") {
                setStep(1);
                setError(msg);
                setLoading(false);
                return;
              }
              if (status === 203) {
                setStep(1);
                setLoading(false);
                navigate("/", {
                  state: {
                    from: "rarityreport",
                    ischeck: true,
                    type,
                    nonMemberGia: giaNumber,
                  },
                });
                return;
              }

              saveCookies(email, attemptedCount);
              if (
                status === 200 &&
                msg === "Verification code sent successfully"
              ) {
                setStep(isEmailAlreadyVerified ? 3 : 2);
                return;
              }
              if (status === 200 && Id && report) {
                navigateReport(Id, report);
              }
              resetForm();
              return;
            }
            setStep(3);
            return;
          }

          // ⏳ Send or resend code
          setCodeError(false);
          setCode("");
          if (lockoutUntil && Date.now() < lockoutUntil) return;

          const { data } = await withoutAuth().post("report/non-member-gia", {
            giaNumber,
            email,
            deviceId,
          });
          const { Id, report, msg, status, type, attemptedCount } = data || {};
          setLoading(false);

          if (Id && report) {
            Cookie.set("nonMemberCredit", 5 - attemptedCount);
            navigateReport(Id, report);
            return;
          }
          if (status === 403 && type === "non-member") {
            setError(msg);
            return;
          }
          if (status === 203) {
            setLoading(false);
            navigate("/", {
              state: {
                from: "rarityreport",
                ischeck: true,
                type,
                nonMemberGia: giaNumber,
              },
            });
            return;
          }
          if (status === 200) {
            setSendCode(true);
            setCount(20);
            return;
          }
        } else {
          // 🔑 Verify code manually
          const { data } = await withoutAuth().post("users/verify-code", {
            giaNumber,
            email,
            code,
            deviceId,
          });
          if (data?.status === 200) {
            setIsVerified(true);
            setFailures(0);
            setCount(0);
            setIsEmailAlreadyVerified(data?.isEmailAlreadyVerified);
          } else if (data?.status === 403) {
            setCodeError(true);
          }
        }
      } else if (step === 3) {
        setLoading(true);
        const { data } = await withAuth().post("report/non-member-gia", {
          giaNumber,
          name,
          email,
          businessName,
          deviceId,
        });
        const { Id, report, msg, status, type, attemptedCount } = data || {};

        if (status === 403 && type === "non-member") {
          setStep(1);
          setError(msg);
          setLoading(false);
          return;
        }
        if (status === 203) {
          saveCookies(email, attemptedCount);
          setLoading(false);
          setStep(1);
          navigate("/", {
            state: {
              from: "rarityreport",
              ischeck: true,
              type,
              nonMemberGia: giaNumber,
            },
          });
          return;
        }

        saveCookies(email, attemptedCount);
        if (Id && report) navigateReport(Id, report);
        resetForm();
      }
    } catch (err) {
      setError(err.message);
      setStep(1);
      setLoading(false);
    } finally {
      setLoader(false);
      setLoading(false);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            <div className="non-member-rarity-form">
              <div className="non-member-rarity-form-login">
                <p
                  onClick={() => {
                    window.parent.location.href = `${process.env.REACT_APP_WP_BASE_URL}/login/?redirect_to=${process.env.REACT_APP_WP_BASE_URL}/rarity-report`;
                  }}
                >
                  Members please Login
                </p>
              </div>
            </div>
            <Form.Group className={`diamond-weight diary-input`}>
              <Form.Control
                type="text"
                placeholder="GIA Report Number"
                value={giaNumber}
                onWheel={(e) => e.target.blur()}
                //  pattern="/^\d{7,10}$/"
                autoFocus={true}
                onChange={(e) => {
                  setGiaNumber(e.target.value);
                }}
                required
              />
            </Form.Group>
            <div className="rarity-process-content rarity-gia-btn pb-0 pt-0">
              {loader ? (
                <PrimaryLoading text={"Loading"} />
              ) : (
                <Button
                  disabled={giaNumber?.length < 7 || giaNumber?.length > 10}
                  className="processBtn newProcessBtn generate-btn"
                  type="submit"
                >
                  {Cookie.get("nonMemberEmail") ? "Generate" : "Next"}
                </Button>
              )}
                
            </div>
            <p
                onClick={() => {
                  setReadRarity(!readRarity);
                }}
              >
               How to read an FCRF Rarity Report?
              </p>
          </>
        );

      case 2:
        return (
          <>
            <h5>Fill in your Email</h5>
            <Form.Group className={`diamond-weight diary-input`}>
              <Form.Control
                type="email"
                placeholder="Email"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
            <div className="opt-input-wrapper">
              <OTPInput
              value={code} 
               onChange={(val) => {
                setCode(val);
                if (val.length === 6) {
                 handleCode(val);
                }
               }}
              numInputs={6}
              renderInput={(props) => (
               <input
                 {...props}
                  disabled={isVerified}  // ✅ disable after verified
                  className={`${sendCode ? "visible" : "invisible"} otp-input-box`}
                />
              )}
              />
              {isVerified && <span className="valid-massage">Code Verifiled</span>}
               {codeError && !lockoutUntil && (
                <div className="invalid-massage">
                  Invalid code
                </div>
              )}
               {lockoutUntil && Date.now() < lockoutUntil && (
                <div style={{ color: "red", marginTop: "5px" }}>
                  Too many attempts. Try again in {lockoutRemaining}s.
                </div>
              )}
            </div>

            {/* <Form.Group
              className={`diamond-weight diary-input ${
                sendCode ? "visible" : "invisible"
              }`}
            >
              <Form.Control
                type="text"
                placeholder="Enter verification code"
                value={code}
                onChange={handleCode}
                isInvalid={codeError}
                isValid={isVerified}
                maxLength={6}
                disabled={!!lockoutUntil && Date.now() < lockoutUntil} // disable input if locked
              />
              
              {codeError && !lockoutUntil && (
                <Form.Control.Feedback type="invalid">
                  Invalid code
                </Form.Control.Feedback>
              )}

              {isVerified && (
                <Form.Control.Feedback type="valid">
                  Code verified
                </Form.Control.Feedback>
              )}

              {lockoutUntil && Date.now() < lockoutUntil && (
                <div style={{ color: "red", marginTop: "5px" }}>
                  Too many attempts. Try again in {lockoutRemaining}s.
                </div>
              )}
            </Form.Group> */}

            <div className="rarity-process-content rarity-gia-btn">
              {loader ? (
                <PrimaryLoading text="Loading" />
              ) : (
                <Button
                  type="submit"
                  className="processBtn"
                  disabled={
                    loader || count > 0 || lockoutRemaining > 0 || !email
                  }
                >
                  {sendCode
                    ? count > 0
                      ? `Resend code in ${count}s`
                      : isVerified
                      ? isEmailAlreadyVerified ? "Generate": "Next"
                      : "Resend code"
                    : "Verify e-mail"}
                </Button>
              )}
            </div>
          </>
        );

      case 3:
        return (
          <>
            <h5>Fill in your info</h5>
            <Form.Group className={`diamond-weight diary-input`}>
              <Form.Control
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className={`diamond-weight diary-input  `}>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  label="Business"
                  className="non-member-rarity-form-radio"
                  checked={accountType === "Business"}
                  onChange={() => setAccountType("Business")}
                />
                <Form.Check
                  inline
                  type="radio"
                  label="Private"
                  className="non-member-rarity-form-radio"
                  checked={accountType === "Private"}
                  onChange={() => setAccountType("Private")}
                />
              </div>
            </Form.Group>
            {accountType === "Business" && (
              <Form.Group className={`diamond-weight diary-input`}>
                <Form.Control
                  type="text"
                  placeholder="Business name"
                  value={businessName}
                  onChange={(e) => setBusinessName(e.target.value)}
                  required
                />
              </Form.Group>
            )}
            <div className="rarity-process-content rarity-gia-btn">
              {loader ? (
                <PrimaryLoading text="Loading" />
              ) : (
                <Button type="submit" className="processBtn">
                  {"Generate"}
                </Button>
              )}
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="non-member-rarity-form">
       {(step > 0 && step < 4) && !Cookie.get("nonMemberEmail") && (
        <div className="mb-4">
          <div className="stepper-container">
            <div className={`step ${step >= 1 ? "active" : ""}`} onClick={() => setStep(1)}>
              <span>1</span>
              {/* <div className="step-label">Report</div> */}
            </div>
            <div className={`step-line ${step >= 2 ? "active" : ""}`} />
            <div className={`step ${step >= 2 ? "active" : ""}`} onClick={() => giaNumber && setStep(2)}>
              <span>2</span>
              {/* <div className="step-label">Email</div> */}
            </div>
            {
              !isEmailAlreadyVerified && <>
                <div className={`step-line ${step >= 3 ? "active" : ""}`} />
                <div className={`step ${step >= 3 ? "active" : ""}`} onClick={() => email && code && isVerified && setStep(3)}>
                  <span>3</span>
                  {/* <div className="step-label">Info</div> */}
                </div>
              </>
            }
          </div>
           
        </div>
      )}
      <Form onSubmit={handleNext}>{renderStep()}</Form>
      <Modal
        className="diary-notice-modal"
        show={!!error}
        onHide={() => setError(null)}
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body>
          {error==="User is already active with same email, please login" ? 
          <div className="text-left non-member-has-reached">
              <p>
               User is already active with same email,<br/><span
               className="non-member-has-reached-link"
                  onClick={() => {
                    window.parent.location.href = `${process.env.REACT_APP_WP_BASE_URL}/login/?redirect_to=${process.env.REACT_APP_WP_BASE_URL}/rarity-report`;
                  }}
                >
                  members please login
                </span>
                
              </p>
            </div>: error ===
          "You have reached the report limit. Please contact support." ? (
            <div className="text-center non-member-has-reached">
              <p>
                FCRF Members get unlimited Rarity Report requests. Click below
                to register.
                <Button
                  className="no-outline-btn processBtn w-100 mt-2 text-light"
                  onClick={() => {
                    window.parent.location.href = `${process.env.REACT_APP_WP_BASE_URL}/membership-plans`;
                  }}
                >
                  <CharFadeText text="Join Now" disabled={false} />
                </Button>
              </p>
            </div>
          ) : (
            <p>{error}</p>
          )}
        </Modal.Body>
      </Modal>
       <Modal show={readRarity} className="how-to-read-rarity-modal" onHide={() => setReadRarity(false)} size="lg" centered>
              <Modal.Header closeButton>  </Modal.Header>
              <iframe src={`https://www.fcresearch.org/how-to-read-an-fcrf-rarity-report/`}  height={"100%"}  
              width={"100%"}
              title="Fancy Color Diamond Diary"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              // allowFullScreen
              
              
              />
            </Modal>
      
    </div>
  );
};

export default NonMemberGiaForm;
